<template>
    <div>
        <div class="dropdown mth-dropdown">
            <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-mth dropdown-toggle">
                <b>{{ currentYear }}</b>
            </span>
            <div class="dropdown-menu dropdown-menu--scrollable">
                <a v-for="(item, key) in yearsList" @click="chooseYear(item)" :key="key" class="dropdown-item mth-item">{{ item }}</a>
            </div>
        </div>
        <div class="btn-arrows" v-if="showButtons">
            <a @click="moveBack()" :disabled="loading" class="btn btn-sm btn-primary text-white first btn-prev"><i class="fal fa-fw fa-chevron-left"></i></a>
            <a @click="moveFwd()" :disabled="loading" class="btn btn-sm btn-primary text-white last btn-next"><i class="fal fa-fw fa-chevron-right"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'yearsCount': {
                type: Number
            },
            'yearStart': {
                type: Number
            },
            'chooseAction': {
                type: Function
            },
            'showButtons': {
                type: Boolean,
                default: function() { return false; }
            },
            'year': {
                type: Number
            },
            'loading': {
                type: Boolean,
                default: function() { return false; }
            }
        },

        data() {
            return {
                'yearsList': [], // [2020, 2021, ...]
                'currentYear': parseInt(this.year)
            };
        },

        mounted() {
            this.createList();
        },

        methods: {
            createList() {
                for(let y=this.currentYear; y>=(this.currentYear-this.yearsCount); y--)
                {
                    if(y>=this.yearStart && y <= parseInt(moment().format("YYYY"))) {
                        this.yearsList.push(y);
                    }
                }
            },

            moveBack() {
                this.currentYear -= 1;

                if(this.yearStart > this.currentYear)
                    this.currentYear = this.yearStart;

                this.chooseYear(this.currentYear);
            },

            moveFwd() {
                this.currentYear += 1;

                if(moment().format("YYYY") < this.currentYear)
                    this.currentYear = moment().format("YYYY");

                this.chooseYear(this.currentYear);
            },

            chooseYear(year) {
                year = parseInt(year);
                this.currentYear = year;

                this.chooseAction(year);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/DropdownYears.vue